import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, KEYWORDS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'keyword',
  url: `${KEYWORDS_URL}/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
